import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'

export interface GameTemplateRecord {
  id: string
  mechanic_id: string
  name: string
  category: string
  description: string
  multi_sensory: boolean
  estimated_time: number
  // Present on the wire (endpoint returns full rows); declared for the
  // admin generate page's layer grouping. Empty allowedLayers = retired.
  allowedLayers?: number[]
  layerCategory?: string | null
}

/**
 * Fetches all game templates from the backend.
 * Templates are effectively static data — cache aggressively.
 */
export function useGameTemplates() {
  return useQuery({
    queryKey: ['game-templates'],
    queryFn: async () => {
      const { data } = await apiClient.get<GameTemplateRecord[]>(
        '/api/content/templates',
      )
      return data
    },
    staleTime: 1000 * 60 * 30, // 30 minutes
  })
}
